<template>
  <Tabs default-value="overview" class="mt-8">
    <TabsList variant="minimal" class="border-b border-gray-100 pb-2">
      <TabsTrigger variant="minimal" value="overview">
        <vue-feather type="book-open" size="15" />
        Overview
      </TabsTrigger>
      <TabsTrigger variant="minimal" value="transcript">
        <vue-feather type="file-text" size="15" />
        Transcript
      </TabsTrigger>
      <TabsTrigger v-if="hasResources" variant="minimal" value="resources">
        <vue-feather type="paperclip" size="15" />
        Resources
      </TabsTrigger>
    </TabsList>

    <TabsContent value="overview" class="pt-5">
      <p v-if="lecture.description" class="max-w-2xl text-[15px] leading-relaxed text-gray-700">
        {{ lecture.description }}
      </p>
      <p v-else class="text-sm italic text-gray-400">No overview for this lesson.</p>
    </TabsContent>

    <TabsContent value="transcript" class="pt-5">
      <div
        v-if="lecture.transcript"
        class="max-h-[28rem] overflow-y-auto rounded-xl border border-gray-100 bg-gray-50/60 p-5"
      >
        <p class="max-w-2xl whitespace-pre-line text-[15px] leading-[1.8] text-gray-600">
          {{ lecture.transcript }}
        </p>
      </div>
      <p v-else class="text-sm italic text-gray-400">No transcript available for this lesson.</p>
    </TabsContent>

    <TabsContent v-if="hasResources" value="resources" class="pt-5">
      <ul class="flex flex-col gap-2">
        <li v-for="asset in lecture.lecture_assets" :key="asset.id">
          <a
            :href="asset.asset_url"
            target="_blank"
            rel="noopener"
            class="group flex items-center gap-3 rounded-lg border border-gray-200 px-4 py-3 transition-colors hover:border-[#202F7E]/40 hover:bg-[#F4F3E3]/40"
          >
            <vue-feather type="download" size="18" class="shrink-0 text-[#4D2542]" />
            <span class="flex-1 text-sm font-medium text-gray-700 group-hover:text-gray-900">{{ asset.name }}</span>
            <vue-feather type="external-link" size="15" class="text-gray-400" />
          </a>
        </li>
      </ul>
    </TabsContent>
  </Tabs>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { LectureWithAssets } from '@/api/agent/university/course';

const props = defineProps<{ lecture: LectureWithAssets }>();

const hasResources = computed(() => props.lecture.lecture_assets.length > 0);
</script>
